<template>
  <v-card>
    <v-card-title>
      <v-row class="align-center" no-gutters>
        <v-col>
          <span class="headline">Task Status</span>
        </v-col>
        <v-col class="d-flex justify-end" cols="auto">
          <TaskLoader />
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <!-- Pass the complete task list to TaskList -->
      <TaskList :tasks="taskStore.tasks" />
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn v-if="taskStore.hasAllTasksCompleted" @click="$emit('close')">
        Close
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts" setup>
  import TaskLoader from './TaskLoader.vue';
  import { useTaskStore } from '@/store/taskStore';
  import TaskList from '@/components/TaskList.vue';

  const taskStore = useTaskStore();

  defineEmits(['close']);
</script>
